(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('newsletter-popup');

    if (!popup) return;

    document.addEventListener('click', function (e) {
      // If popup is open and click is outside it → close it
      if (popup.hasAttribute('open') && !popup.contains(e.target)) {
        popup.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
